import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { USER_VALIDATION_QUERY } from '../../graphql';
import { CheckUserExistsResponse } from '../../models';

@Injectable({ providedIn: 'root' })
export class MemberService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  checkUserExistsByEmail(
    email: string,
    accountDnvId: string | null,
  ): Observable<CheckUserExistsResponse> {
    const fieldName =
      getQueryRootFieldName(USER_VALIDATION_QUERY) || 'isUserExists';

    return this.apollo
      .use(this.clientName)
      .query({
        query: USER_VALIDATION_QUERY,
        variables: {
          email,
          accountDnvId,
        },
        fetchPolicy: 'no-cache',
        context: {
          headers: new HttpHeaders().set('SKIP_LOADING', 'true'),
        },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.isUserExists),
      );
  }
}
